import { CustomTable } from "@/components/Tables/CustomTable"
import { columns } from "./Columns"
import { useCustomQuery } from "@/hooks/useCustomQuery"
import AddContactModal from "./Model"
import { CrudProvider, useCrudContext } from "@/context/crudContext"

export default function CustomerList() {
  const breadcrumbs = [
    { label: "Dashboard", url: "/pos/dashboard" },
    { label: "Attribute Type" },
  ]
  return (
    <>
      {/* Breadcrumb */}
      <div className="breadcrumb-card">
        <h5>Attribute Type</h5>
      </div>

      <CrudProvider>
        <PaymentMethodTable />
      </CrudProvider>
    </>
  )
}

function PaymentMethodTable() {
  const { openDialog } = useCrudContext()

  return (
    <>
      <CustomTable
        label="Attributes Type"
        columns={columns}
        apiPath="settings"
        hardcodedFilters={{ key: "attribute" }}
      />

      {openDialog ? <AddContactModal /> : null}
    </>
  )
}
